export default __webpack_public_path__ + "static/media/nmp3.621f5e71.png";